import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { Switch, styled } from '@mui/material';

export class Checkbox extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      active: props.defaultChecked || false,
      checked:false,
    };
  }

  onChange = e => {
    const { value } = this.props;
    const { active } = this.state;
    e.target.value = value;
    e.target.checked = this.getStatus();
    this.props.onChange( e );
    this.setState( { active: !active } );
  }

  getStatus() {
    const { checked } = this.props;
    const { active } = this.state;
    return checked === undefined ? active : checked;
  }

  AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },

    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
        },
      },
    },

    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },

    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));

  handleChange = (event) => {
    this.setState({checked:event.target.checked})
  };
  render() {
    const { title, titleFirst, value, showInlineNoWrapText } = this.props;
    const status = this.getStatus();
    const titleComponent = showInlineNoWrapText ? <span className="checkbox-text">{ title }</span> : <span className="checkbox-text">{ title }</span>;
    const className = classNames( 'checkbox-frame', { 'title-first': titleFirst, 'checkbox-first': !titleFirst, 'active': status } );

    return !this.props.fromConfigurator?<div className="checkbox-panel">
      { titleFirst && titleComponent }
      <div className={ className } onClick={ this.onChange }>
        <div className="checkmark"/>
      </div>
      { !titleFirst && titleComponent }
    </div>:<>
      { titleFirst && titleComponent }
      <Switch checked={this.state.checked}
      onChange={this.handleChange} onClick={ this.onChange }/>
    </>;
  }
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.node,
  titleFirst: PropTypes.bool,
  value: PropTypes.string,
};